import {
  AADetectionResults,
  AdBlockerType,
  PageViewEventType,
  SoftwallRecoveredType,
} from "../types";
import { sendEvent, isSessionRecovered } from "../utils";
import { log } from "../utils/logs";

export const onPageView = async (
  rlEnabled: boolean,
  recovered: SoftwallRecoveredType,
  aaDetectionResults: AADetectionResults,
  detectedExtension: AdBlockerType,
  consentMessageShown: boolean,
  attributionExpiry: number,
) => {
  if (!window.__bt_intrnl.rlPVSent) {
    window.__bt_intrnl.rlPVSent = true;
    let event: PageViewEventType = "non_ab_pageview";
    if (aaDetectionResults.ab) {
      event = aaDetectionResults.aa ? "aa_pageview" : "ab_pageview";
    }

    const isActive = isSessionRecovered(recovered, attributionExpiry);

    // As we always load RL script from tag
    // we should send PV event only if RL is enabled
    // OR if RL is already disabled, but user was recovered and attribution window has not expired yet
    if (rlEnabled || isActive) {
      sendEvent({
        event,
        detectedExtension,
        consentMessageShown,
        recoveryType: recovered, // track recovery type on page view event, this will allow us to see if page view state is caused by RL recovery
        attributionExpired: recovered ? !isActive : null, // track if recovered attribution has already expired to highlight if RL script take conversions from this page view
      }).catch((error) => {
        log(
          "rlink.onPageViewError",
          {
            aaResults: window.__bt_intrnl.aaDetectionResults,
            error: error instanceof Error ? error.message : error,
          },
          { severity: 4 },
        );
      });
    }
  }
};
